export default "__VITE_ASSET__CLJsbewU__"